const state = {
  all: []
}

const mutations = {
  addLegendasList (state, res) {
    state.all.push(res.data)
  },
  updateLegendasList (state, res) {
    state.all = res.data
  }
}

const actions = {
  createLegenda (context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/legendas', data).then((res) => {
      context.commit('addLegendasList', res)
      return res
    })
  },
  updateLegenda (context, data) {
    var id = data.id
    let qs = require('querystring')
    var dados = qs.stringify(data.legenda)
    return window.axios.put('/api/v2/legendas/' + id, dados).then((res) => {
      return res
    })
  },
  deleteLegenda (context, id) {
    return window.axios.delete('/api/v2/legendas/' + id).then((res) => {
      return res
    })
  },
  listLegendas (context, id) {
    return window.axios.get('/api/v2/legendas/controlador/' + id).then((res) => {
      context.commit('updateLegendasList', res)
      return res
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Legendas.js